import { RouteComponentProps } from 'react-router-dom';

import { IWithContextProps, withContext } from '@tock/coretypes';
import { initHelloJS } from 'components/OAuth';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ConsumerOverlay from 'components/ConsumerOverlay';

class OAuthRedirRoute extends BaseComponent<RouteComponentProps & IWithContextProps> {
  componentDidMount() {
    initHelloJS();
  }

  render() {
    return <ConsumerOverlay isLoading={true}>{''}</ConsumerOverlay>;
  }
}

export default withContext(OAuthRedirRoute);
